import React from 'react'

import screenshot1 from './dex-contact-pipelines.png';
import screenshot2 from './dex-contact-leads.png';
import screenshot3 from './dex-contact-labels.png';
import polymedia_png from './polymedia-peter-van-der-meer.png';

import StartFooterCTA from './StartFooterCTA.js'


export default class extends React.Component {
  render() {
    return (
      <div>
        <div className="full header accent">
          <div className="wrap">
            <div>
                <div className="col-2">
                  <h1 style={{textAlign:"left", margin:"1em 0 0"}}>CRM for Makers</h1>
                  <h2 style={{textAlign:"left", margin:"0 0 2em"}}>Use DEX to manage your contacts, label them, and guide them through pipelines.</h2>
                  <button onClick={() => this.props.openModal("register")} className="btn btn-f btn-fat">Sign up for a free trial</button>
                  <small style={{opacity:".5", display:"block", marginTop:"3em", fontSize:"75%"}}>Use all features for free with the 50-contact trial, you only need an email address to get started.</small>
                </div>
                <div className="col-2"><img src={screenshot2} alt="dex.polymedia.nl | dashboard lead pipeline" className="screenshot" style={{border:"1px solid #afafaf"}} /></div>
            </div>
          </div>
        </div>

        <div className="full accent">
          <div className="wrap wrap-thin">
            <div dangerouslySetInnerHTML={{__html: '<iframe src="https://citrus.polymedia.nl/poll/4O7PbnHeQrzQtORfbX6DJV5fhTZu2ZUo?embed&lang=en" height="215" style="border:0;width:100%"></iframe>'}} />
          </div>
        </div>

        <div className="full">
          <div className="wrap">
            <h2 style={{textAlign:"center"}}>Convert your leads</h2>
              <div className="col-2" style={{padding:"1em"}}>
                <h3 style={{marginBottom:"0"}}>Track your activity with labels</h3><p style={{marginTop:"1em"}}>You can create your own labels, making it possible to use any wording you want to track your activity while converting your leads from first contact to registered users or paying customers.</p>
              </div>
              <div className="col-2"><img src={screenshot2} alt="dex.polymedia.nl | dashboard convert leads" className="screenshot" /></div>
          </div>
        </div>

        <div className="full greyish">
          <div className="wrap">
            <h2 style={{textAlign:"center"}}>Label your contact data</h2>
              <div className="col-2" style={{padding:"1em"}}>
                <h3 style={{marginBottom:"0"}}>Keep labels and metadata</h3><p style={{marginTop:"1em"}}>There are 8 pre-defined fields for your contact's metadata, and one "Other" field type. You are free to use any fields however you want, and multiple times as well. Fields like "Name", or "LinkedIn", or "Twitter", to store the data you need. Besides this, you can create your own labels, and add as many of them as you want to the contact.</p>
              </div>
              <div className="col-2"><img src={screenshot3} alt="dex.polymedia.nl | dashboard label contacts" className="screenshot" /></div>
          </div>
        </div>

        <div className="full">
          <div className="wrap">
            <h2 style={{textAlign:"center"}}>Create pipelines</h2>
              <div className="col-2" style={{padding:"1em"}}>
                <h3 style={{marginBottom:"0"}}>Guide your contacts</h3><p style={{marginTop:"1em"}}>You are free to create any pipeline you want, but the most common example would probably be to track the contact from lead to paying customer. You can create any label you want, apply them to the contact, and then create any number of pipelines you need, to view and track them in this flow.</p>
              </div>
              <div className="col-2"><img src={screenshot1} alt="dex.polymedia.nl | dashboard create pipelines example" className="screenshot" /></div>
          </div>
        </div>

        <div className="full big accent">
          <div className="wrap content-block">
              <div className="col-2"><img src={polymedia_png} alt="dex.polymedia.nl | who is polymedia.nl" className="screenshot" style={{margin:"0"}} /></div>
              <div className="col-2">
                <h1 style={{margin:"1rem 0", textAlign:"center"}}>Who is Polymedia?</h1>
                <p style={{fontSize:"20px", textAlign:"left", marginTop:"0"}}>Polymedia consists of a single experienced developer that has developed and maintained multiple popular Extensions for Twitch, the most known are Twitter Feed+ and Instagram Feed+, two Twitch Extensions that daily hundreds of new streamers install on their profiles.<br/><br/>After over five years of development on multiple Twitch Extensions, I realized that I wanted to focus on SaaS Web Applications that I have complete control over. I have been learning about Software-as-a-Service for years, and as evidenced by my LinkedIn, I have a lot of professional work experience building them.</p>
                <div className="socials"><a href="https://www.linkedin.com/in/peterdotplus/" target="_blank" rel="noopener noreferrer" style={{marginRight:"42px"}}>LinkedIn</a><a href="https://x.com/PolymediaNL" target="_blank" rel="noopener noreferrer">Twitter</a></div>
              </div>
          </div>
        </div>

        <div className="full big">
          <div className="wrap wrap-thin content-block">
            <h2 style={{marginBottom:".7em"}}>Frequently Asked Questions</h2>
            <h3 style={{margin:"1em 0 0"}}>What are the features?</h3>
            <p style={{margin:"0"}}>DEX is a simple Customer Relationship Management (CRM) or contacts system, with some extended features. It is possible to add any metadata you want to any contact, and to add any label you create. You can also use pipelines to follow the contacts in a workflow, based on these labels. Metadata, labels and pipelines have no limits and are fully configurable to your wishes.</p>
            <h3 style={{margin:"1em 0 0"}}>What is the advantage of a CRM?</h3>
            <p style={{margin:"0"}}>A separate Customer Relationship Management (CRM) system allows for the organization of contact information. Using only a mailbox or your Direct Messages can easily get frustrating and confusing, as you have to keep checking every message to know the current status. Especially if you do client or lead outreach a CRM can help you organize your workflow.</p>
            <h3 style={{margin:"1em 0 0"}}>What are the costs?</h3>
            <p style={{margin:"0"}}>DEX is currently completely FREE! Your contacts are only limited in number, with a limit of 50 contacts at a time. You can delete older contacts to free up space, so if you do lead outreach you can just remove leads that have gone cold or have converted. You can create unlimited metadata, labels and pipelines. Pricing will come later if there is enough interest.</p>
          </div>
        </div>

        <StartFooterCTA openModal={this.props.openModal} />

      </div>
    );
  }

}



// WEBPACK FOOTER //
// ./src/containers/Start.js